import type { PostHog } from 'posthog-js';
import posthog from 'posthog-js';

import * as envConfig from '@/constants/env';

let posthogInstance: PostHog | null = null;

export const _resetForTesting = () => {
  posthogInstance = null;
};

export const initializePostHog = (options?: Record<string, any>): PostHog | null => {
  if (!envConfig.POSTHOG_KEY || !envConfig.POSTHOG_HOST) {
    return null;
  }

  posthogInstance ??= posthog.init(envConfig.POSTHOG_KEY, {
    api_host: envConfig.POSTHOG_HOST,
    session_recording: {
      recordCrossOriginIframes: true,
      maskAllInputs: false,
      maskInputOptions: {
        password: true
      }
    },
    error_tracking: {
      captureExtensionExceptions: false
    },
    ...options
  });

  return posthogInstance;
};

export const getPostHog = (): PostHog | null => {
  return posthogInstance;
};
